import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { FeedbackDisplayHeaderComponent } from './feedback-display-header.component';

export const ngxFeedbackDisplayHeaderModule = angular.module('ngxFeedbackDisplayHeaderModule', [])
	.directive('ngxFeedbackDisplayHeader', downgradeComponent({ component: FeedbackDisplayHeaderComponent }))
	.name;
